import type {CreateExtArgs} from '@wix/document-manager-core'
import {getAccessibilitySettings, setAccessibilitySettings, extractLanguageCode} from './utils'
import {RTL_LANGUAGES, LanguageDirection} from './types'
import _ from 'lodash'

export interface LanguageDirectionAPI {
    isRTL(languageCode: string): boolean
    getSiteDirection(): string
    setSiteDirection(siteDirection: string): void
}

export const createLanguageDirectionAPI = (createExtArgs: CreateExtArgs): LanguageDirectionAPI => {
    const isRTL = (languageCode: string): boolean => {
        if (!languageCode || typeof languageCode !== 'string' || languageCode.trim() === '') {
            throw new Error('Error: languageCode is required')
        }

        const extractedLanguageCode = extractLanguageCode(languageCode)
        return (RTL_LANGUAGES as readonly string[]).includes(extractedLanguageCode)
    }

    const getSiteDirection = (): string => {
        const settings = getAccessibilitySettings(createExtArgs)
        return _.get(settings, ['currentSiteDirection']) || 'ltr'
    }

    const setSiteDirection = (siteDirection: string): void => {
        if (!['ltr', 'rtl'].includes(siteDirection)) {
            throw new Error('Site direction must be either "ltr" or "rtl"')
        }

        setAccessibilitySettings(createExtArgs, {
            currentSiteDirection: siteDirection as LanguageDirection
        })
    }

    return {
        isRTL,
        getSiteDirection,
        setSiteDirection
    }
}
